

import React from "react";
import { FaPlus, FaCalendarAlt } from "react-icons/fa";
import MedtrustHeader from "../../Compoents/MedtrustHeader";
import MedtrustFooter from "../../Compoents/MedtrustFooter";
import BreadcrumbArea from "../../ShearOne/BreadcrumbArea";

const HospitalStories = () => {
  const testimonials = [
    {
      videoUrl:
        "https://www.youtube.com/embed/UClF9cDUu2Y",
      date: "October 19, 2022",
      title: "Multiple Myeloma Treatment in India | Patient Testimonial",
      description:
        "Explore the dynamic commerce through our insightful blogs. Learn more about modern healthcare innovation and patient experiences.",
    },
    {
      videoUrl:
        "https://www.youtube.com/embed/l5z4O8Gv2CA",
      date: "October 19, 2022",
      title: "Bone Marrow Transplant for Hodgkin's Lymphoma Cancer",
      description:
        "Explore the dynamic commerce through our insightful blogs. Discover breakthrough treatments and global patient journeys.",
    },
    {
      videoUrl:
        "https://www.youtube.com/embed/UClF9cDUu2Y",
      date: "October 19, 2022",
      title: "Flourishing Healthier Revive Radiance",
      description:
        "Explore the dynamic commerce through our insightful blogs. Experience world-class medical excellence and care.",
    },
    {
      videoUrl:
        "https://www.youtube.com/embed/UClF9cDUu2Y",
      date: "October 19, 2022",
      title: "Multiple Myeloma Treatment in India | Patient Testimonial",
      description:
        "Explore the dynamic commerce through our insightful blogs. Learn more about modern healthcare innovation and patient experiences.",
    },
    {
      videoUrl:
        "https://www.youtube.com/embed/l5z4O8Gv2CA",
      date: "October 19, 2022",
      title: "Bone Marrow Transplant for Hodgkin's Lymphoma Cancer",
      description:
        "Explore the dynamic commerce through our insightful blogs. Discover breakthrough treatments and global patient journeys.",
    },
    {
      videoUrl:
        "https://www.youtube.com/embed/UClF9cDUu2Y",
      date: "October 19, 2022",
      title: "Flourishing Healthier Revive Radiance",
      description:
        "Explore the dynamic commerce through our insightful blogs. Experience world-class medical excellence and care.",
    },
  ];
  const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Hospital Stories', active: true }
    ];

  return (
    <div className="min-h-screen bg-[#f5f7fa]">
      <MedtrustHeader />
      <BreadcrumbArea
                    title="Hospital Stories"
                    backgroundImage="assets/imgs/banner-3/banner-1.png"
                    links={breadcrumbLinks}
                />

      <section className="pt-[140px] pb-20 px-20 lg:px-25">

        {/* 3 COLUMN GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {testimonials.map((item, index) => (
            
            <div
  key={index}
  className="bg-white rounded-[22px] overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.002)] transition-all duration-300 hover:shadow-[0_14px_40px_rgba(0,0,0,0.08)]"
>
  {/* Top Media */}
  <div className="w-full h-[190px]">
    <iframe
      src={item.videoUrl}
      title={item.title}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className="w-full h-full"
    />
  </div>

  {/* Card Content */}
  <div className="p-6">
    {/* Date Row */}
    <div className="flex items-center gap-2 text-gray-500 text-xs mb-3">
      <FaCalendarAlt className="text-[12px]" />
      <span>{item.date}</span>
    </div>

    {/* Title */}
    <h3 className="text-[18px] font-semibold text-[#0f172a] leading-snug mb-3">
      {item.title}
    </h3>

    {/* Description */}
    <p className="text-gray-500 text-[14px] leading-relaxed mb-5">
      {item.description}
    </p>

    {/* View More */}
    <div className="flex items-center gap-3 font-semibold text-[#0f172a] text-sm cursor-pointer">
      <span>View More</span>
      <div className="w-7 h-7 rounded-full bg-[#0a42c4] flex items-center justify-center text-white text-[10px]">
        <FaPlus />
      </div>
    </div>
  </div>
</div>


          ))}
        </div>
      </section>

      <MedtrustFooter />
    </div>
  );
};

export default HospitalStories;